import { useEffect, useState } from 'react'
import { Alert, Button, Col, Container, Image, Row } from 'react-bootstrap'
import styles from './reviewOrder.module.css'
import checkOrder from '../../../../assests/icons/order_check.png'
import checkDraft from '../../../../assests/icons/order.png'
export const ReviewOrder = ({
  type = 'primary',
  show,
  orderData,
  productLabels,
  sampleProductLabels,
  onConfirm,
  onCancel,
}) => {
  const handleCancel = () => {
    if (onCancel) onCancel()
  }

  const handleConfirm = () => {
    if (onConfirm) onConfirm()
  }

  const orderItems = orderData?.orderDetailsRequestDtos || []
  const sampleItems = orderData?.sampleDetailsRequestDtos || []

  const orderSubtotal = orderItems.reduce((sum, item) => {
    const product = productLabels?.[item.productId] || {}
    const price = product.price || 0

    return sum + price * (item.quantity || 0)
  }, 0)

  const sampleSubtotal = sampleItems.reduce((sum, item) => {
    const product = sampleProductLabels?.[item.productId] || {}
    const price = product.price || 0

    return sum + price * (item.quantity || 0)
  }, 0)

  // const total = orderSubtotal + sampleSubtotal;

  const totalOrderQty = orderItems.reduce(
    (sum, item) => sum + (item.quantity || 0),
    0,
  )

  const totalSampleQty = sampleItems.reduce(
    (sum, item) => sum + (item.quantity || 0),
    0,
  )

  const grandTotalQty = totalOrderQty + totalSampleQty
  return (
    <>
      {show && (
        <div className={styles.backdrop}>
          <Container className='h-100 d-flex align-items-center justify-content-center'>
            <Row className='w-100 justify-content-center'>
              <Col xs={10} sm={8} md={6} lg={6}>
                <div className={styles.alert_main}>
                  <Alert variant={type}>
                    <Alert.Heading
                      className={`d-flex flex-column align-items-center text-center ${styles.reviewHeading}`}
                      style={{ fontWeight: 100 }}
                    >
                      <Image
                        src={checkOrder}
                        alt='Order Check'
                        className={`mb-2 ${styles.reviewHeaderImg}`}
                      />
                      {orderData.orderType} Summary{' '}
                    </Alert.Heading>
                    <p className={styles.totalBoxCount}>
                      {grandTotalQty} {grandTotalQty > 1 ? 'Cartons' : 'Carton'}{' '}
                      in total
                    </p>

                    {/* <hr /> */}
                    <section>
                      <div className={styles.customerCard}>
                        <h5>{orderData.customer?.companyName}</h5>
                      </div>
                    </section>
                    <hr />

                    {/* ORDER ITEMS */}
                    <h5 className={styles.sectionTitle}>
                      Order Items |{' '}
                      {totalOrderQty > 1
                        ? totalOrderQty + ' Ctns'
                        : totalOrderQty + ' Ctn'}
                    </h5>
                    <div className={styles.itemList}>
                      {orderItems.map((item, i) => {
                        const product = productLabels?.[item.productId] || {}

                        const label = product.label || ''
                        const price = product.price || 0
                        // const lineTotal = price * (item.quantity || 0);
                        return (
                          <div className={styles.itemRow} key={i}>
                            <section className={styles.left}>{i + 1}</section>
                            <section className={styles.right}>
                              <h6>{label}</h6>
                              <div className={styles.meta}>
                                <div>Qty : {item.quantity}</div>
                                <div>
                                  Subtotal :{' '}
                                  {(price * item.quantity).toFixed(2)} €
                                </div>
                              </div>
                            </section>
                          </div>
                        )
                      })}
                      <div className={styles.subtotal}>
                        Total HT : <strong>{orderSubtotal.toFixed(2)} €</strong>
                      </div>
                    </div>
                    {/* SAMPLE ITEMS */}
                    {sampleItems.length > 0 && (
                      <>
                        <hr />
                        <h5 className={styles.sampleSectionTitle}>
                          Promotion / Sample Items |{' '}
                          {totalSampleQty > 1
                            ? totalSampleQty + ' Ctns'
                            : totalSampleQty + ' Ctn'}
                        </h5>

                        <div className={styles.sampleItemList}>
                          {sampleItems.map((item, i) => {
                            const product =
                              sampleProductLabels?.[item.productId] || {}

                            const label = product.label || ''
                            const price = product.price || 0
                            const lineTotal = price * (item.quantity || 0)

                            return (
                              <div className={styles.itemRow} key={i}>
                                <section className={styles.left}>
                                  {i + 1}
                                </section>

                                <section className={styles.right}>
                                  <h6>{label}</h6>

                                  <div className={styles.meta}>
                                    <div>Qty : {item.quantity}</div>

                                    <div>
                                      Subtotal : {lineTotal.toFixed(2)} €
                                    </div>
                                  </div>
                                </section>
                              </div>
                            )
                          })}

                          <div className={styles.subtotal}>
                            Total HT :{' '}
                            <strong>{sampleSubtotal.toFixed(2)}€</strong>
                          </div>
                        </div>
                      </>
                    )}

                    <div
                      className={`d-flex justify-content-end mt-2 ${styles.btnGrp}`}
                    >
                      <Button onClick={handleConfirm} variant='outline-success'>
                        Confirm
                      </Button>
                      <Button
                        onClick={handleCancel}
                        variant='outline-danger'
                        className='ms-2'
                      >
                        Cancel
                      </Button>
                    </div>
                  </Alert>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  )
}
